enum LandingActionTypes {
  loadMapLayers = '[Landing] Load Map Layers',
  loadMapLayersSuccess = '[Landing] Load Map Layers Success',
  loadMapLayersFailure = '[Landing] Load Map Layers Failure',

  setActiveMapLayers = '[Landing] Set Active Map Layers',
  addLayerToMap = '[Landing] Add Layer to Map',
  removeLayerFromMap = '[Landing] Remove Layer From Map',


  addLayerSource = '[Landing] Add Layer Source',
  removeLayerSource = '[Landing] Remove Layer Source',

  setIsCleared = '[Landing] Set Is Cleared Status',

  setCurrentMap = '[Landing] Set Current Map'
}

import {createAction, props} from '@ngrx/store';
import {MapGroup} from '../../../shared/classes/map-group';
import {MapLayer} from '../../../shared/classes/map-layer';
import Map from 'ol/Map';


export const LoadMapLayers = createAction(LandingActionTypes.loadMapLayers);
export const LoadMapLayersSuccess = createAction(
  LandingActionTypes.loadMapLayersSuccess,
  props<{ mapLayerGroups: MapGroup[] }>(),
);
export const LoadMapLayersFailure = createAction(
  LandingActionTypes.loadMapLayersFailure,
  props<{ error: unknown }>(),
);

export const AddLayerToMap = createAction(
  LandingActionTypes.addLayerToMap,
  props<{ mapLayer: MapLayer }>(),
);

export const RemoveLayerFromMap = createAction(
  LandingActionTypes.removeLayerFromMap,
  props<{ layerHandle: string }>(),
);

export const AddLayerSource = createAction(
  LandingActionTypes.addLayerSource,
  props<{ mapLayer: MapLayer }>(),
);

export const RemoveLayerSource = createAction(
  LandingActionTypes.removeLayerSource,
  props<{ mapLayer: MapLayer }>(),
);

export const SetActiveMapLayers = createAction(
  LandingActionTypes.setActiveMapLayers,
  props<{ activeMapLayers: MapLayer[] }>(),
);

export const SetCurrentMap = createAction(
  LandingActionTypes.setCurrentMap,
  props<{ map: Map }>(),
);



